import styled from 'styled-components';
import Btn022 from '../Btn022';

export const ElementWrapper = styled.div`
  background-color: transparent;
  border-top: 1px solid rgba(38, 50, 56, 0.12);
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
`;
export const Button = styled(Btn022)`
  margin: 6px;
  cursor: pointer;
  color: #0099a9;
`;
